/* eslint-disable max-len */
export enum unavailableFeatureTypes {
    SHOW_UNAVAILABLE_FEATURE_POPUP = 'SHOW_UNAVAILABLE_FEATURE_POPUP',
    HIDE_UNAVAILABLE_FEATURE_POPUP = 'HIDE_UNAVAILABLE_FEATURE_POPUP',
    HANDLE_UNAVAILABLE_FEATURE_POPUP_ERROR = 'HANDLE_UNAVAILABLE_FEATURE_POPUP_ERROR',
}
